import { Component, ViewEncapsulation } from '@angular/core';
import { SuperAdminService } from './super-admin.service';
import { DumbAdmin } from './DTOs/dumb-admin';
import { NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UIBlockingService } from '../core/ui-blocking.service';
import { AddEditSuperAdminModalComponent } from './Modals/add-edit-super-admin-modal.component';
import { GetAdminsRequest } from './DTOs/get-admins-request';
import { AdminDtRetInfo } from './DTOs/admin-dt-ret-info';
import { Observable, forkJoin, merge } from 'rxjs';
import { ToastNotificationService } from '../core/toast-notification.service';

@Component({
  selector: 'app-super-admin-management',
  templateUrl: './super-admin-management.component.html',
  providers: [UIBlockingService, NgbDropdown],
  encapsulation: ViewEncapsulation.None
})
export class SuperAdminManagementComponent {
  constructor(private superAdminService: SuperAdminService
    , private blockUI: UIBlockingService
    , private notificationService: ToastNotificationService
    , private modalService: NgbModal) {

  }

  superAdmins: DumbAdmin[] = [];
  totalAdmin = 0;
  filteredAdmin = 0;
  pageNum = 1;
  itemsPerPage = 10;
  searchText = "";
  statusSearch = { display: "Active", value: 1 };
  sortType = 1;
  keywordSearches: string[] = [];
  filtersChanged = true;
  initialLoad = true;
  get currentPageNum() { return this.pageNum };
  set currentPageNum(page: number) {
    this.pageNum = page;
    if (!this.initialLoad)
      this.getSuperAdmins();
  }
  get itemStart() {
    if (this.superAdmins.length == 0) {
      return 0;
    } else return ((this.currentPageNum - 1) * this.itemsPerPage) + 1;
  }
  get itemEnd() {
    return ((this.currentPageNum - 1) * this.itemsPerPage) + this.superAdmins.length;
  }

  ngOnInit() {
    var observablesMerged = merge(this.getSuperAdminsObservable());
    this.blockUI.start();
    observablesMerged.subscribe(
      {
        next: (data) => {
          this.superAdmins = data.data;
          this.totalAdmin = data.recordsTotal;
          this.filteredAdmin = data.recordsFiltered;
          this.initialLoad = false;
        },
        error: (err) => {
          this.notificationService.error(err.error.message);
          this.blockUI.stop();
          console.log(err)
        },
        complete: () => {
          this.blockUI.stop();
        }
      });
  }

  getSuperAdminsObservable(): Observable<AdminDtRetInfo> {
    var req = this.createSearchRequest();
    return this.superAdminService
      .getAllSuperAdmins(req);
  }

  getSuperAdmins() {
    this.blockUI.start();

    this.getSuperAdminsObservable()
      .subscribe(
        {
          next: (data) => {
            this.superAdmins = data.data;
            this.totalAdmin = data.recordsTotal;
            this.filteredAdmin = data.recordsFiltered;
          },
          error: (err) => {
            this.notificationService.error(err.error.message);
            this.blockUI.stop();
            console.log(err)
          },
          complete: () => {
            this.blockUI.stop();
          }
        });
  }

  addAdmin() {
    const modalRef = this.modalService.open(AddEditSuperAdminModalComponent, { size: 'lg', backdrop: 'static' });
    modalRef.componentInstance.admin = new DumbAdmin();
    modalRef.componentInstance.headerText = "Add Super-Admin";
    modalRef.componentInstance.adding = true;
    modalRef.result.then(response => {
      this.getSuperAdmins();
    })
      .catch(err => {

      }).finally();
  }
  editAdmin(admin: DumbAdmin) {
    const modalRef = this.modalService.open(AddEditSuperAdminModalComponent, { size: 'lg', backdrop: 'static' });
    modalRef.componentInstance.admin = admin;
    modalRef.componentInstance.headerText = "Edit Super-Admin";
    modalRef.componentInstance.adding = false;
    modalRef.result.then(response => {
      this.getSuperAdmins();
    })
      .catch(err => {

      }).finally();
  }

  createSearchRequest(): GetAdminsRequest {
    var req = new GetAdminsRequest();

    if (this.filtersChanged)
      this.pageNum = 1;

    req.PageNumber = this.pageNum - 1; //to get the 0-indexed number
    req.ItemsPerPage = this.itemsPerPage;

    req.KeywordSearches = this.keywordSearches;
    req.Sorting = this.sortType;
    req.StatusFilter = this.statusSearch.value;

    this.filtersChanged = false;

    return req;
  }

  triggerAdminPasswordReset(contactId) {
    this.blockUI.start();
    this.superAdminService.SendAdminPasswordReset(contactId)
      .subscribe(
        {
          next: (data) => {
            this.notificationService.success("Password reset email sent successfully.");
          },
          error: (err) => {
            this.notificationService.error(err.error.message);
            this.blockUI.stop();
            console.log(err)
          },
          complete: () => {
            this.blockUI.stop();
          }
        });
  }

  enterSearchTerm(event: any) {
    if (event.keyCode != 13)//13 is enter, 32 is space
      return;

      this.searchText.trim().split(' ').forEach((term) => this.keywordSearches.push(term));
    this.searchText = '';
    this.filtersChanged = true;
    this.getSuperAdmins();
    return;
  }

  removeSearchTerm(term: string) {
    var index = this.keywordSearches.indexOf(term);
    if (index != -1) {
      this.keywordSearches.splice(index, 1);
      this.filtersChanged = true;
    }
    this.getSuperAdmins();
  }

  changeStatusSearch(toChange: number) {
    if (this.statusSearch.value == toChange)
      return;

    this.filtersChanged = true;
    switch (toChange) {
      case 1:
        this.statusSearch = { display: "Active", value: 1 };
        break;
      case 2:
        this.statusSearch = { display: "Deactivated", value: 2 };
        break;
      case 3:
        this.statusSearch = { display: "All", value: 3 };
        break;
      default:
        this.statusSearch = { display: "Active", value: 1 };
        break;
    }
  }
  clearSearch() {
    this.searchText = "";
    this.statusSearch = { display: "Active", value: 1 };
    this.sortType = 1;
    this.keywordSearches = [];
    this.filtersChanged = true;
    this.getSuperAdmins();
  }
    hitSearchBtn() {
    this.searchText.trim().split(' ').forEach((term) => this.keywordSearches.push(term));
    this.searchText = '';
    this.filtersChanged = true;
    this.getSuperAdmins();
  }
  changeSortType(column: number) {
    switch (column) {
      case 1:
        if (this.sortType == 1)
          this.sortType = 2;
        else this.sortType = 1;
        break;
      case 2:
        if (this.sortType == 3)
          this.sortType = 4;
        else this.sortType = 3;
        break;
      default:
        break;
    }
    this.filtersChanged = true;
    this.getSuperAdmins();
  }
}
